<div class="container">
  <h2 class="title">Contacto</h2>
  <div class="flex-container first-container">
    <div class="flex-item mail">
      <a href="mailto:cinoi@um.edu.uy">cinoi@um.edu.uy</a>
    </div>
    <div class="flex-item info-box">
      Envíanos tus consultas y nuestro equipo se pondrá en contacto a la mayor brevedad posible.
    </div>
  </div>
  <div class="flex-container second-container">
    <div class="flex-item latu-picture-container"><img class="latu-picture" src="assets/img/latu.png" alt="LATU"></div>
    <div class="flex-item latu-info">
      <img class="location-pin" src="assets/img/pin-de-ubicacion.png" alt="pin de ubicación">
      <p>Próximamente en el Parque Tecnológico del LATU</p>
    </div>
  </div>
</div>

<div class="fill-space"></div>

<div class="screen-bottom-positioning">
  <div class="blue-horizontal-line"></div>
  <app-footer></app-footer>
</div>
